<swiper-container
  slides-per-view="1"
  [navigation]="slidesData.length > 1 ? 'true' : 'false'"
  lazy="true"
  pagination="true"
  keyboard="true"
  >
  @for (slide of slidesData; track slide) {
    <swiper-slide
      >
      <ng-container
        *ngTemplateOutlet="slideTemplate.first; context: { $implicit: slide }"
        >
      </ng-container>
    </swiper-slide>
  }
</swiper-container>
